/* Collection filter and sort panels. On desktop: a small
   smcp button that reveals an absolutely positioned bordered panel. */
(function () {
  'use strict';

  /* ---------------------------------------------- the mobile filter panel
     `.refine-box--sheet` is fixed and translated off
     to the left; `.refine-box--opened` brings it in. The page behind it
     is locked while it is open, as the nav overlay does. */
  var popup = document.querySelector('[data-filters-popup]');
  var openBtn = document.querySelector('[data-filters-open]');
  if (popup && openBtn) {
    var setPopup = function (on) {
      popup.classList.toggle('refine-box--opened', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
    };
    openBtn.addEventListener('click', function () { setPopup(true); });
    [].slice.call(document.querySelectorAll('[data-filters-close]')).forEach(function (b) {
      b.addEventListener('click', function () { setPopup(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('refine-box--opened')) setPopup(false);
    });
    /* A resize past the breakpoint must not leave the body locked. */
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) setPopup(false);
    });
  }

  var toggles = [].slice.call(document.querySelectorAll('[data-filter-toggle]'));
  if (!toggles.length) return;

  function closeAll(except) {
    toggles.forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var panel = t.nextElementSibling;
      if (panel) panel.classList.remove('refine__pane--opened');
    });
  }

  toggles.forEach(function (t) {
    t.addEventListener('click', function (e) {
      e.stopPropagation();
      var panel = t.nextElementSibling;
      var open = t.getAttribute('aria-expanded') === 'true';
      closeAll(t);
      t.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.classList.toggle('refine__pane--opened', !open);
    });
  });

  document.addEventListener('click', function (e) {
    /* Inside the mobile panel the accordions are the whole interface - an
       outside-click handler that closes every one makes it unusable. */
    if (popup && popup.classList.contains('refine-box--opened')) return;
    if (e.target.closest && e.target.closest('.refine__pane')) return;
    closeAll(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
